import { del, get, post, put } from '../utils/axios'

export const getEducationAPI = async (body) => {
  return await get('edu', body)
}
export const getEducationTypeAPI = async () => {
  return await get('edu/types')
}

export const getTypeFileAPI = async (body) => {
  return await get('edu/file', body)
}

export const createEducationAPI = async (body) => {
  return await post('edu', body)
}
export const updateFileEducationAPI = async (body) => {
  return await post('/edu/file', body)
}
export const createEducationGroupAPI = async (body) => {
  return await post('edu/groups', body)
}
export const updateEducationAPI = async (param, body) => {
  return await put('edu', param, body)
}
export const deleteEducationAPI = async (param) => {
  return await del('edu', param)
}
